import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AchDebit } from '../../../settings-data/sub-models/company-settings/ach-debit.model';
import { PercentagePipe } from '../../../shared/pipes/percentage/percentage.pipe';
import { MoneyPipe } from '../../../shared/pipes/money/money.pipe';

@Injectable()
export class SetupBankTransferDialogBuilder {
  constructor(
    private _translateService: TranslateService,
    private _percentagePipe: PercentagePipe,
    private _moneyPipe: MoneyPipe
  ) {}

  buildDescription(achDebit: AchDebit, locale: string): string {
    const currencyCode = achDebit.currencyCode;
    const translateParams = {
      feesPercentage: this._percentagePipe.transform(
        achDebit.feesPercentage,
        locale
      ),
      feesMaximum: this._moneyPipe.transform(
        achDebit.feesMaximum,
        currencyCode,
        locale
      ),
      feesMinimum: this._moneyPipe.transform(
        achDebit.feesMinimum,
        currencyCode,
        locale
      ),
    };

    return this._translateService.instant(
      'DIALOG.PAYMENTS.DESCRIPTION.SETUP_BANK_TRANSFER',
      translateParams
    );
  }
}
